var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-responsive',{attrs:{"id":"mapContainer","aspect-ratio":1.5}},[_c('link',{attrs:{"rel":"stylesheet","type":"text/css","href":"https://js.api.here.com/v3/3.1/mapsjs-ui.css"}}),_c('div',{ref:"map",attrs:{"id":"locationsMap"}})])}
var staticRenderFns = []

export { render, staticRenderFns }